import { Chart, RectangleStackIcon } from 'components'
import { DCFilter } from 'types'
import { useBreakpoint } from 'utils'
import { StatTile } from '..'
import { useEvent, useOnTheGo } from '../../utils'
import { useAggregations } from '../../utils/analyticsUtils'

export default function AnalyticsContentSection() {
  const isMobile = useBreakpoint() < 2
  const { event, filters: eventFilters = [], setFilters: setEventFilters } = useEvent()
  const { filters: onTheGoFilters = [], setFilters: setOnTheGoFilters } = useOnTheGo()
  const filters = event ? eventFilters : onTheGoFilters
  const setFilters = event ? setEventFilters : setOnTheGoFilters
  const { aggregations } = useAggregations([
    {
      table: 'sessionMetrics',
      values: ['_count', 'duration_avg'],
      categories: ['title'],
      sort: { _count: 'DESC' },
      filters: [
        { field: 'groupTitle', operator: 'eq', value: '_action', table: 'sessionMetrics' },
        ...filters,
      ],
    },
  ])

  const [content] = aggregations || {}
  if (!content?.data?.length) return null

  function handleSelect(value: string) {
    const selectedFilters: DCFilter[] = [
      {
        field: 'groupTitle',
        operator: 'eq',
        value: '_action',
        table: 'sessionMetrics',
      },
      {
        field: 'title',
        operator: 'ILIKE',
        value: value,
        table: 'sessionMetrics',
      },
    ]
    setFilters([...(filters || []), ...selectedFilters])
  }

  return (
    <StatTile
      key="programChart"
      alignItems="stretch"
      height="500px"
      label="Programs by Session Count & Avg. Time"
      num={content.data.length}
      Icon={RectangleStackIcon}
      canCopy
    >
      <Chart
        type="combo"
        {...content}
        valueInfo={[
          { label: 'Count', type: 'bars' },
          { label: 'Average duration', type: 'scatter', axis: 'secondary' },
        ]}
        onSelect={
          isMobile
            ? undefined
            : ({ label }) => {
                handleSelect(label)
              }
        }
        orientation="column"
        primaryAxisTitle="Count"
        secondaryAxisTitle="Duration (seconds)"
      />
    </StatTile>
  )
}
